module.exports = __webpack_public_path__ + "img/fn-0.1b0f082.svg";